import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { AChartComponent } from "../../components/achart/achart.component";

@Injectable()
export class ChartInstanceService {
    public select: Subject<AChartComponent> = new Subject<AChartComponent>();
    public unselect: Subject<AChartComponent> = new Subject<AChartComponent>();

    public charts: AChartComponent[] = [];
    private _selectedChart: any = null;
    public get selectedChart(): AChartComponent {
        return this._selectedChart;
    }
    public set selectedChart(v: AChartComponent) {
        this._selectedChart = v;
    }

    public registerChart(chart: AChartComponent) {
        this.charts.push(chart);
    }

    public unregisterChart(chart: AChartComponent) {
        this.charts = this.charts.filter(x => x.itemID != chart.itemID);
    }

    public getChart(id: string) {
        return this.charts.find(c => c.itemID == id);
    }

    constructor() {
        this.select.subscribe(chart => {
            if (chart !== this.selectedChart && this.selectedChart) {
                this.selectedChart.isSelected = false;
            }
            this._selectedChart = chart;
        });
        this.unselect.subscribe(chart => {
            this._selectedChart = null;
        });
    }
}
